import React from "react";
import {ImageConfig} from "../../../../constants";
import {CommonService} from "../../../../shared/services";
import "./FacilityTimingsModalComponent.scss";
import SkeletonCard from "../../../../shared/components/skeleton-card/SkeletonCard";

interface Timing {
    start_time: number;
    end_time: number;
}

interface FacilityTiming {
    day: string;
    day_name: string;
    timings?: Timing | null;
}

interface FacilityTimingsModalProps {
    setIsDayTimingsModalOpen?: (isOpen: boolean) => void;
    facilityDetails?: {
        name?: string;
        address?: string;
        timings?: FacilityTiming[];
    };
    isFacilityDetailsLoading?: any
}

// List of all days to ensure all 7 days appear
const ALL_DAYS: FacilityTiming[] = [
    {day: "1", day_name: "Monday"},
    {day: "2", day_name: "Tuesday"},
    {day: "3", day_name: "Wednesday"},
    {day: "4", day_name: "Thursday"},
    {day: "5", day_name: "Friday"},
    {day: "6", day_name: "Saturday"},
    {day: "7", day_name: "Sunday"},
];

// Format the time range or show "Closed" in red
const formatTimings = (timing?: Timing | null): JSX.Element => {
    return timing ? (
        <span
            className={'timings-text flex-2 d-flex ts-justify-content-center'}>{`${CommonService.getHoursAndMinutesFromMinutes(timing.start_time)} - ${CommonService.getHoursAndMinutesFromMinutes(timing.end_time)}`}</span>
    ) : (
        <span className="closed-text flex-2  d-flex ts-justify-content-center">Closed</span>
    );
};

// Generate paired timings ensuring all 7 days exist
const getPairedTimings = (timings: FacilityTiming[] = []): FacilityTiming[][] => {
    const timingsMap = new Map(timings.map((t) => [t.day, t]));

    // Ensure every day exists in the list, marking missing days as "Closed"
    const completeTimings: FacilityTiming[] = ALL_DAYS.map((day) => ({
        ...day,
        timings: timingsMap.get(day.day)?.timings || null,
    }));

    // Pair the timings
    return completeTimings.reduce<FacilityTiming[][]>((pairs, timing, index) => {
        if (index % 2 === 0) {
            pairs.push([timing, completeTimings[index + 1] || null]);
        }
        return pairs;
    }, []);
};

const FacilityTimingsModalComponent: React.FC<FacilityTimingsModalProps> = ({
                                                                                isFacilityDetailsLoading,
                                                                                setIsDayTimingsModalOpen,
                                                                                facilityDetails
                                                                            }) => {
    const pairedTimings = getPairedTimings(facilityDetails?.timings);

    return (
        <div className="operating-hours-modal">
            {isFacilityDetailsLoading && <SkeletonCard/>}
            {!isFacilityDetailsLoading && <div>
                <div className="modal-title d-flex justify-content-space-between">
                    <div>
                        {facilityDetails?.name} -
                        ({CommonService.formatAddressBillAppointment(facilityDetails?.address ?? "")})
                    </div>
                    <div
                        className="cursor-pointer close-button"
                        onClick={() => setIsDayTimingsModalOpen?.(false)}
                    >
                        <ImageConfig.CloseIcon color="#1479FF"/>
                    </div>
                </div>
                <div className="modal-subtitle mrg-bottom-25 mrg-top-10">Operating hours for this location:</div>
                <table className="hours-table">
                    <thead>
                    <tr>
                        <th>
                            <div className="d-flex ">
                                <span className={''}>Day of Week</span>
                                <span className={'flex-1 mrg-left-30'}>Hours of Operation</span>
                            </div>
                        </th>
                        <th>
                            <div className="d-flex ">
                                <span className={''}>Day of Week</span>
                                <span className={'flex-1 mrg-left-30'}>Hours of Operation</span>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {pairedTimings.map(([day1, day2], index) => (
                        <tr key={index}>
                            <td>
                                <div className="d-flex justify-content-space-between">
                                    <span className={'flex-1 d-flex'}>{day1.day_name}</span>
                                    {formatTimings(day1.timings)}
                                </div>
                            </td>
                            <td>
                                {day2 && (
                                    <div className="d-flex">
                                        <span className={'flex-1 d-flex'}>{day2.day_name}</span>
                                        {formatTimings(day2.timings)}
                                    </div>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>}
        </div>
    );
};

export default FacilityTimingsModalComponent;
